var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L8 12",
    stroke: "#14181F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.666L8 11.9993L6 10.666",
    stroke: "#14181F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9987 14H3.9987C3.63051 14 3.33203 13.7015 3.33203 13.3333L3.33203 2.66667C3.33203 2.29848 3.63051 2 3.9987 2L9.04076 2C9.22646 2 9.40376 2.07746 9.52993 2.21373L12.4879 5.40831C12.602 5.53154 12.6654 5.6933 12.6654 5.86125L12.6654 13.3333C12.6654 13.7015 12.3669 14 11.9987 14Z",
    stroke: "#14181F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 6L9.33464 6C8.96645 6 8.66797 5.70152 8.66797 5.33333L8.66797 2",
    stroke: "#14181F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.68df075f02530614da951d7e0a0063e8.svg";
export { ForwardRef as ReactComponent };